import { Component, Output, EventEmitter, Input } from '@angular/core';
import { EmployeeService } from '../../../shared/services/employee.service';
import { TimeOffRequestBus } from '../../../shared/models/TimeOffRequestBus';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { RequestTimeOffReference } from '../../../shared/models/RequestTimeOffReference';
import { SchedulerEvent, SlotClickEvent } from '@progress/kendo-angular-scheduler';

@Component({
    selector: 'emp-timeoff-edit',
    templateUrl: './emp-timeoff-edit.component.html',
    styleUrls: ['./emp-timeoff-edit.component.scss'],
    standalone: false
})
export class EmpTimeoffEditComponent {
    constructor(private svc_data: EmployeeService) {
    }
  public active = false;
  public editForm: UntypedFormGroup = new UntypedFormGroup({
    'timeOffRequestId': new UntypedFormControl(),
    'companyId': new UntypedFormControl(),
    'requestedPersonId': new UntypedFormControl(),
    'dateRequested': new UntypedFormControl(),
    'hours': new UntypedFormControl(),
    'mins': new UntypedFormControl(),
    'statusId': new UntypedFormControl(),
    'insertDt': new UntypedFormControl(),
    'insertedByUserId': new UntypedFormControl(),
    'notes': new UntypedFormControl(),
    'timeOffTypeId': new UntypedFormControl(),
    'nonPaid': new UntypedFormControl(false),
    'rejectAcceptMsg': new UntypedFormControl()

  });
  @Input() public isNew = false;
  @Input() public data_ref: RequestTimeOffReference;
  @Input() public set model(model: TimeOffRequestBus) {
    this.editForm.reset(model);
    this.active = model !== undefined;
  }

  public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<TimeOffRequestBus> = new EventEmitter();

  
  readOnly: boolean = false;
  data: TimeOffRequestBus;
  selectedDate: Date = new Date(Date.now());
  events: SchedulerEvent[] = [];
    selectedHrs: number = 0
    selectedMins: number = 0;

  public onSave(e): void {
    //    let data: TimeOffRequestBus = new TimeOffRequestBus(this.editForm.value);
    e.preventDefault();
    this.save.emit(this.editForm.value);
    this.active = false;
  }

  public onCancel(e): void {
    e.preventDefault();
    this.closeForm();
  }

  private closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }
  dateChanged(e: any) {
  }
  eventClick(e: any) {
  }
  slotClick(e: SlotClickEvent) {
    this.selectedDate = e.start;
    //this.editForm.value.dateRequested = this.selectedDate;
    this.editForm.controls["dateRequested"].setValue(this.selectedDate);
  }
}
